import projectGdriveFileListComponent from './project-gdrive-file-list.component';

const projectGdriveFileListModule = angular.module('projectGdriveFileList', [
])
  .component('projectGdriveFileList', projectGdriveFileListComponent)
  .name;

export default projectGdriveFileListModule;
